// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import './NewsPage.css';
// import AllIntroTemplate from "../../components/AllIntroTemplate/AllIntroTemplate.js";
// import totalData from "../../json/data.json";
// import NewsModel from '../../components/NewsModel/NewsModel.js';
// import News from '../News/News.js';

// const NewsPage = () => {
//   const { id } = useParams();
//   const [newsData, setNewsData] = useState(null); 
//   const [loading, setLoading] = useState(true); 

//   useEffect(() => {
//     const fetchNewsData = async () => {
//       try {
//         const response = await fetch(`https://msconstruction.vercel.app/news/${id}`);
//         const data = await response.json();
//         setNewsData(data); 
//         setLoading(false);
//       } catch (error) {
//         console.error("Error fetching news data:", error);
//         setLoading(false);
//       }
//     };

//     fetchNewsData();
//   }, [id]);

//   if (loading) return <p>Loading...</p>; 
//   if (!newsData) return <p>News article not found.</p>; 

//   return (
//     <div>
//       <AllIntroTemplate 
//         image={newsData.photo}
//         title={newsData.title}
//         page={totalData[0]} 
//       />
//       <NewsModel data={newsData}/>
//     </div>
//   );
// };

// export default NewsPage;

import React, { useEffect, useState, Suspense, lazy } from 'react';
import { useParams } from 'react-router-dom';
import './NewsPage.css';
import totalData from "../../json/data.json";

// Lazy load components
const AllIntroTemplate = lazy(() => import("../../components/AllIntroTemplate/AllIntroTemplate.js"));
const NewsModel = lazy(() => import('../../components/NewsModel/NewsModel.js'));

const NewsPage = () => {
  const { id } = useParams();
  const [newsData, setNewsData] = useState(null); 
  const [loading, setLoading] = useState(true); 

  useEffect(() => {
    const fetchNewsData = async () => {
      try {
        const response = await fetch(`https://pranusha.vercel.app/news/${id}`);
        const data = await response.json();
        setNewsData(data); 
        setLoading(false);
      } catch (error) {
        console.error("Error fetching news data:", error);
        setLoading(false);
      }
    };

    fetchNewsData();
  }, [id]);

  if (loading) return <p>Loading...</p>; 
  if (!newsData) return <p>News article not found.</p>; 

  return (
    <div>
      <Suspense fallback={<p>Loading intro...</p>}>
        <AllIntroTemplate 
          image={newsData.photo}
          title={newsData.title}
          page={totalData[0]} 
        />
      </Suspense>

      <Suspense fallback={<p>Loading news content...</p>}>
        <NewsModel data={newsData}/>
      </Suspense>
    </div>
  );
};

export default NewsPage;
